import { render } from "./CookiePolicyPage.vue?vue&type=template&id=7ae803dc&scoped=true"
import script from "./CookiePolicyPage.vue?vue&type=script&lang=ts"
export * from "./CookiePolicyPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-7ae803dc"

export default script